<template>
	<div
		v-if="searchToolActiveFrameName !== null"
		@click="onClick"
		class="search-tool-turn-off-button-wrapper"
	>
		<AppIconButton @click="onClick" :type="IconTypes.SEARCH" />
		<div class="search-tool-turn-off-close">
			<AppIconButton :size="20" :icon-size="12" />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { SAFE_COORDINATE_OUTSIDE_MAP } from "@/config/constants";
import useEmitter, { EmitterEvents, TileLabelAction } from "@/hooks/useEmitter";
import useRuntimeStore from "@/store/useRuntimeStore";
import { TileLabelSkin } from "@/types/tile";
import { IconTypes } from "@/types/ui";
import { storeToRefs } from "pinia";
import { markRaw } from "vue";
import AppIconButton from "../AppIconButton.vue";

const emitter = markRaw(useEmitter());

const runtimeStore = useRuntimeStore();
const { searchToolActiveFrameName } = storeToRefs(runtimeStore);

const onClick = (): void => {
	emitter.emit(EmitterEvents.PhaserUpdateTileLabel, {
		coordinates: {
			x: SAFE_COORDINATE_OUTSIDE_MAP,
			y: SAFE_COORDINATE_OUTSIDE_MAP,
		},
		skin: TileLabelSkin.SEARCH_TOOL,
		action: TileLabelAction.DELETE_ALL,
	});
	runtimeStore.setSearchToolActiveFrameName(null);
};
</script>

<style scoped lang="scss">
.search-tool-turn-off-button-wrapper {
	margin-right: 0.5rem;
	width: 2.5rem;
	height: 2.5rem;
	:deep(.app-button-search) {
		border-image-source: linear-gradient(to top, #bd9032, #f0d386);
		background-image: linear-gradient(to top, #181a1d, #303239);
	}

	.search-tool-turn-off-close {
		position: absolute;
		top: -0.5rem;
		right: 0.125rem;
	}
}
</style>
